import { createSlice } from "@reduxjs/toolkit";

export interface FolderState {
  clearSearchSignal: number;
}

const initialState: FolderState = {
  clearSearchSignal: 0,
};

const clearFolderSeachBoxSlice = createSlice({
  name: "clearFolderSeachBox",
  initialState,
  reducers: {
    triggerClearSearch: (state) => {
      state.clearSearchSignal += 1;
    },
  },
});

export const { triggerClearSearch } = clearFolderSeachBoxSlice.actions;
export default clearFolderSeachBoxSlice.reducer;
